import { defineStore, DefineStoreOptions } from 'pinia';
import { FetchBusinessListByGroupCodeResponse } from '@dto';
import { GROUP_CODE } from '@constants';

interface BusinessCodeStoreState {
  businessCodeLists: Map<GROUP_CODE, FetchBusinessListByGroupCodeResponse[]>;
}
interface BusinessCodeStoreGetters {
  getBusinessLists: (
    state: BusinessCodeStoreState
  ) => (code: GROUP_CODE) => FetchBusinessListByGroupCodeResponse[];
}
interface BusinessCodeStoreActions {}

type BusinessCodeStoreOptions = DefineStoreOptions<
  string,
  BusinessCodeStoreState,
  BusinessCodeStoreGetters,
  BusinessCodeStoreActions
>;

const businessCodeStoreId = 'business';
const businessCodeStoreOptions: BusinessCodeStoreOptions = {
  id: businessCodeStoreId,
  state: () => ({ businessCodeLists: new Map() }),
  getters: {
    getBusinessLists: (state: BusinessCodeStoreState) => (code: GROUP_CODE) =>
      state.businessCodeLists.get(code) || [],
  },
  actions: {
    setBusinessLists(
      code: GROUP_CODE,
      list: FetchBusinessListByGroupCodeResponse[]
    ) {
      this.businessCodeLists.set(code, list);
    },
  },
};

export const useBusinessCodeStore = defineStore(
  businessCodeStoreId,
  businessCodeStoreOptions
);
